/* eslint new-cap: ["error", { "capIsNew": false }]*/
import { List, fromJS, Map, Set } from 'immutable';
import { RestAPI } from '@/util/net';
import { putError } from '@/store/error.store';
import { markStoreLoading, markStoreLoaded } from '@/store/storeForStoringStatusOfStores.store';

function checkIfToday(data) {
  return (new Date(data.startDate) <= new Date() &&
   new Date(new Date(data.endDate).getTime() + 86400000) > new Date());
}

export const eventsLoaded = (state, action) =>
  state.clear().merge(fromJS(action.data));

export const todayEventsLoaded = (state, action) =>
  state.clear().merge(fromJS(action.data));

const hideEvent = (state, id) => {
  const hiddenState = state.get('hidden');
  if (hiddenState) {
    return state.set('hidden', hiddenState.add(id));
  }
  return state.set('hidden', new Set().add(id));
};

export const eventUpdated = (state, action) =>
  state.map(event =>
    (event.get('id') == action.data.id ? event.merge(fromJS(action.data)) : event));

export const eventUpdatedTodayStore = (state, action) => {
  const idx = state.findIndex(event => (event.get('id') == action.data.id));
  if (checkIfToday(action.data)) {
    if (idx == -1) {
      return state.push(fromJS(action.data));
    }
    return state.set(idx, fromJS(action.data));
  } else if (idx > -1) {
    return state.delete(idx);
  }
  return state;
};

export const clearEvents = (state) => state.clear();

const eventDeleted = (state, action) =>
  state.delete(state.findIndex(item => item.get('id') == action.id));

const eventCreated = (state, action) => state.push(fromJS(action.data));

const eventCreatedTodayStore = (state, action) => {
  if (checkIfToday(action.data)) {
    return state.push(fromJS(action.data));
  }
  return state;
};

const storeEventToEdit = (state, event) => state.set('item', event);

const clearEventToEdit = (state) => state.delete('item');

const forgetDeleteId = (state) => state.delete('delete');
const storeDeleteId = (state, id) => state.set('delete', id);

const dealUpdated = (state, data, dealType) => {
  let newState = state;
  // update and delete old events
  newState = state.map(event => {
    if (event.get(dealType) == data.id) {
      if (!data.calendarEvents) {
        return null;
      }
      const dataEvent = data.calendarEvents.find(e => e.id == event.get('id'));
      if (dataEvent) {
        return event.merge(fromJS(dataEvent));
      }
      return null;
    }
    return event;
  });
  // pushing new events
  if (data.calendarEvents) {
    data.calendarEvents.forEach(event => {
      const idx = state.findIndex(e => e.get('id') == event.id);
      if (idx == -1) {
        newState = newState.push(fromJS(event));
      }
    });
  }
  return newState.filter(evt => evt != null);
};

const dealDeleted = (state, id, dealType) => {
  const newState = state.map(event => (event.get(dealType) == id ? null : event));
  return newState.filter(evt => evt != null);
};

export const eventsEditReducer = (state = Map(), action) => {
  switch (action.type) {
    case 'EVENT_EDIT_STARTED':
      return storeEventToEdit(state, action.eventDto);
    case 'EVENT_EDIT_FINISHED':
      return clearEventToEdit(state);
    default:
      return state;
  }
};

export const eventReducer = (state = Map(), action) => {
  switch (action.type) {
    case 'DELETE_EVENT_UNCONFIRMED':
      return forgetDeleteId(state);
    case 'CONFIRM_EVENT_DELETE':
      return storeDeleteId(state, action.id);
    case 'TODAYS_EVENT_HIDDEN':
      return hideEvent(state, action.id);
    default:
      return state;
  }
};

export const eventsListReducer = (state = List(), action) => {
  switch (action.type) {
    case 'CLEAR_EVENTS':
      return clearEvents(state, action);
    case 'EVENTS_LOADED':
      return eventsLoaded(state, action);
    case 'EVENT_UPDATED_SUCCESSFULLY':
      return eventUpdated(state, action);
    case 'EVENT_DELETED':
      return eventDeleted(state, action);
    case 'EVENT_CREATED_SUCCESSFULLY':
      return eventCreated(state, action);
    case 'EVENT_EDIT_STARTED':
      return storeEventToEdit(state, action.eventDto);
    case 'DEAL_UPDATE_SUCCESSFULLY':
      return dealUpdated(state, action.data, action.dealType);
    case 'WS_RECEIVED_DEAL_DELETED':
      return dealDeleted(state, action.id, action.dealType);
    default:
      return state;
  }
};

export const todayEventListReducer = (state = List(), action) => {
  switch (action.type) {
    case 'TODAY_EVENTS_LOADED':
      return todayEventsLoaded(state, action);
    case 'DEAL_UPDATE_SUCCESSFULLY':
      return dealUpdated(state, action.data, action.dealType);
    case 'WS_RECEIVED_DEAL_DELETED':
      return dealDeleted(state, action.id, action.dealType);
    case 'EVENT_CREATED_SUCCESSFULLY':
      return eventCreatedTodayStore(state, action);
    case 'EVENT_UPDATED_SUCCESSFULLY':
      return eventUpdatedTodayStore(state, action);
    case 'EVENT_DELETED':
      return eventDeleted(state, action);
    default:
      return state;
  }
};

export const editEvent = (dispatch, eventDto) => {
  dispatch({ type: 'EVENT_EDIT_STARTED', eventDto });
};
export const editEventFinished = (dispatch) => {
  dispatch({ type: 'EVENT_EDIT_FINISHED' });
};

export const deleteEvent = (dispatch, id) => {
  dispatch({ type: 'EVENT_DELETE_STARTED' });
  return RestAPI.delete(`/calendar/api/${id}`)
    .then(() => { dispatch({ type: 'EVENT_DELETED', id }); return true; })
    .catch(() => { dispatch({ type: 'EVENT_DELETE_FAILED' }); return true; });
};

export const clearDeleteConfirm = (dispatch) => {
  dispatch({ type: 'DELETE_EVENT_UNCONFIRMED' });
};
export const confirmDelete = (dispatch, id) => {
  dispatch({ type: 'CONFIRM_EVENT_DELETE', id });
};

export const loadEvents = (dispatch) => {
  markStoreLoading(dispatch, 'events');
  dispatch({ type: 'EVENT_LOADING_STARTED' });
  return RestAPI.get('/calendar/api').then((data) => {
    dispatch({ type: 'EVENTS_LOADED', data });
    markStoreLoaded(dispatch, 'events');
    return true;
  });
};

export const loadTodayEvents = (dispatch) => {
  markStoreLoading(dispatch, 'today_events');
  dispatch({ type: 'TODAY_EVENTS_LOADING' });
  return RestAPI.get('/calendar/api/today').then((data) => {
    dispatch({ type: 'TODAY_EVENTS_LOADED', data });
    markStoreLoaded(dispatch, 'today_events');
    return true;
  });
};
export const hideTodaysEvent = (dispatch, id) => {
  dispatch({ type: 'TODAYS_EVENT_HIDDEN', id });
};

export const updateEvent = (dispatch, eventDto) => {
  dispatch({ type: 'EVENT_UPDATE_STARTED', data: eventDto });
  return RestAPI.patch(`/calendar/api/${eventDto.id}`, eventDto)
    .then(
      () => {
        dispatch({ type: 'EVENT_UPDATED_SUCCESSFULLY', data: eventDto });
        return true;
      }
    ).catch(
      (data) => {
        putError(dispatch, data);
        dispatch({ type: 'EVENT_UPDATE_FAILED' });
        return true;
      }
    );
};

export const createEvent = (dispatch, eventDto) => {
  dispatch({ type: 'EVENT_CREATION_STARTED', data: eventDto });
  return RestAPI.post('/calendar/api', eventDto)
    .then(
      (response) => {
        dispatch({ type: 'EVENT_CREATED_SUCCESSFULLY', data: response });
        return true;
      }
    ).catch(
      (data) => {
        putError(dispatch, data);
        dispatch({ type: 'EVENT_CREATION_FAILED' });
        return true;
      }
    );
};
